import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

interface CompensationAnomalyState {
  hasAnomalousRows: boolean;
}

const initialState: CompensationAnomalyState = {
  hasAnomalousRows: false,
};

export const compensationAnomalySlice = createSlice({
  name: 'compensationAnomaly',
  initialState,
  reducers: {
    setHasAnomalousRows: (state, action: PayloadAction<boolean>) => {
      state.hasAnomalousRows = action.payload;
    },
    clearAnomalousRows: (state) => {
      state.hasAnomalousRows = false;
    },
  },
});

export const { setHasAnomalousRows, clearAnomalousRows } = compensationAnomalySlice.actions;

export default compensationAnomalySlice.reducer;

export interface CompensationAnomalyRootState {
  compensationAnomaly: CompensationAnomalyState;
}

export const useHasAnomalousRows = () =>
  useSelector((state: CompensationAnomalyRootState) => state.compensationAnomaly.hasAnomalousRows);
